<template>
  <div class="loans-root">
    <div>
      <Form @submit="onSubmit">
        <Card title="用户信息">
          <Field
            v-model="username"
            name="name"
            label="姓名"
            left-icon="contact"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <Field
            v-model="phoneNUmber"
            name="mobile"
            label="手机号"
            type="tel"
            left-icon="phone-circle-o"
            placeholder="请输入联系方式"
            :rules="[{ required: true, message: '请填写联系方式' }]"
          />
        </Card>
        <Card title="车辆信息">
          <Field
            v-model="car_brand"
            name="car_brand"
            label="汽车品牌"
            left-icon="award-o"
            placeholder="请输入汽车品牌"
            :rules="[{ required: true, message: '请填写汽车品牌' }]"
          />
          <Field
            v-model="car_model"
            name="car_model"
            label="汽车型号"
            left-icon="logistics"
            placeholder="请输入汽车型号"
            :rules="[{ required: true, message: '请填写汽车型号' }]"
          />
          <Field
            v-model="h_number"
            name="changed_times"
            label="过户次数"
            type="number"
            left-icon="flag-o"
            placeholder="请输入数字"
            :rules="[{ required: true, message: '请填写过户次数' }]"
          />
          <Field
            v-model="price"
            name="money_needed"
            label="需求金额"
            type="number"
            left-icon="balance-o"
            right-icon="gold-coin-o"
            placeholder="请输入金额"
            :rules="[{ required: true, message: '请填写金额' }]"
          />
        </Card>
        <Card title="备注">
          <Field
            v-model="message"
            rows="2"
            autosize
            name="notes"
            type="textarea"
            maxlength="50"
            placeholder="请填写备注信息"
            show-word-limit
          />
        </Card>
        <div style="margin: 16px;">
          <Button round block type="info" native-type="submit">
            提交
          </Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { api,http } from 'utils/'
import Card from '@/components/Card'
export default {
  data() {
    return{
      showPicker:false,
      username:"",
      phoneNUmber:"",
      h_number:"",
      car_brand:"",
      car_model:"",
      price:"",
      message:""
    }
  },
  components:{
    Card
  },
  created() {
    document.title = '车辆贷款'
  },
  methods:{
    async postHandle(data) {
      const res = await http({
        url:api.insurceApi,
        method:'POST',
        data:{
          ...data,
          service_type:3
        }
      })
      if(res) {
        this.$router.push('/success')
      }
      console.log(res)
    },
    onSubmit(values) {
      this.postHandle(values)
      console.log('submit', values);
    }
  }
}
</script>

<style lang="less">
.loans-root{
  padding: 20px 12px;
  width: 100%;
  height: 100%;
  overflow: auto;
  .van-cell__title {
    text-align: left;
  }
}
</style>